import {useMutation, useQueryClient} from 'react-query'
import {updateStageUser} from '../core/_requests'
import {Toast} from '../../../../_metronic/partials/widgets'
import {Task} from '../core/_models'
import {formatDateToBrazilian, sortKanbanTasks} from '../../../../_metronic/helpers'
import { useParams } from 'react-router-dom'

type Props = {
  draggedTask: Task
  fromColumn: string
  toColumn: string
}

export function useMoveTask() {
  const queryClient = useQueryClient()
  const theme = window.localStorage.getItem('kt_theme_mode_value') || ''
  const {userId} = useParams()

  return useMutation(
    async ({draggedTask, fromColumn, toColumn}: Props) =>
      updateStageUser(draggedTask.id, toColumn, 0, Number(userId)),
    {
      onMutate: ({draggedTask, fromColumn, toColumn}) => {
        const oldFrom = queryClient.getQueryData(['tasks-by-user-kanban', `filter_status=${fromColumn}&userId=${userId}`])
        const oldTo = queryClient.getQueryData(['tasks-by-user-kanban', `filter_status=${toColumn}&userId=${userId}`])

        queryClient.setQueryData(
          ['tasks-by-user-kanban', `filter_status=${fromColumn}&userId=${userId}`],
          (tasks?: Task[]) => tasks?.filter((task) => task.id !== draggedTask.id) ?? []
        )

        queryClient.setQueryData(
          ['tasks-by-user-kanban', `filter_status=${toColumn}&userId=${userId}`],
          (tasks?: Task[]) => {
            const updatedDraggedTask = {
              ...draggedTask,
              end_date:
                toColumn == 'entregue' ? formatDateToBrazilian(new Date().toDateString()) : null,
              updated_at: new Date().toISOString(),
            } as Task

            // @ts-ignore
            const sortedTasks = sortKanbanTasks([...(tasks ?? []), updatedDraggedTask], toColumn)
            return [...sortedTasks]
          }
        )

        return {oldFrom, oldTo}
      },
      onError: (error: any, {fromColumn, toColumn}, context: any) => {
        Toast.fire({
          icon: 'error',
          title: error.response?.data?.message || 'Ocorreu um erro inesperado',
          customClass: {
            popup: 'bg-light-danger',
            title: theme === 'dark' ? 'text-dark' : 'text-danger',
          },
        })

        queryClient.setQueryData(
          ['tasks-by-user-kanban', `filter_status=${fromColumn}&userId=${userId}`],
          context?.oldFrom
        )
        queryClient.setQueryData(['tasks-by-user-kanban', `filter_status=${toColumn}&userId=${userId}`], context?.oldTo)
      },
    }
  )
}
